import {
  useSelect,
  type UseSelectState,
  type UseSelectStateChangeOptions,
} from "downshift";

import { MultiSelectItem } from "./MultiSelect.types";

export function itemToString(item: MultiSelectItem | null) {
  return item ? item.title : "";
}

export function stateReducer<T extends MultiSelectItem>(
  state: UseSelectState<T>,
  actionAndChanges: UseSelectStateChangeOptions<T>
) {
  const { changes, type } = actionAndChanges;

  switch (type) {
    case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
    case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
    case useSelect.stateChangeTypes.ItemClick: {
      return {
        ...changes,
        isOpen: true,
        highlightedIndex: state.highlightedIndex,
      };
    }
    default: {
      return changes;
    }
  }
}

export function getButtonText(
  items: MultiSelectItem[],
  selectedItems: MultiSelectItem[]
) {
  if (items.length === selectedItems.length) {
    return "All";
  }

  if (selectedItems.length === 1) {
    return selectedItems[0]?.title;
  }

  if (selectedItems.length > 1) {
    return `${selectedItems.length} items selected`;
  }

  return "None";
}
